import { MetaType, LayoutType } from "../types"
import { actionCreatorGuard, reducerGuard, reducerActions } from "../reducers"

export const kind = "seq_configs"

export type SeqConfig = {
  kind: typeof kind
  version: number
  name: string
  layout: LayoutType
  config: string
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<SeqConfig, MetaType>("meta", kind),
  name: actionCreatorGuard<SeqConfig, string>("name", kind),
  layout: actionCreatorGuard<SeqConfig, LayoutType>("layout", kind),
  config: actionCreatorGuard<SeqConfig, string>("config", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    SeqConfig,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const seqConfigAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const seqConfigReducer = reducerGuard<SeqConfig>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.name)
  .case(...reducerAction.layout)
  .case(...reducerAction.config)
  .build()
